import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.135 1.71a.75.75 0 0 0-1.5 0 1.63 1.63 0 0 1-.651 1.305 5.1 5.1 0 0 0-1.968 0 1.64 1.64 0 0 1-.65-1.305.75.75 0 1 0-1.5 0 3.14 3.14 0 0 0 .623 1.875 5.1 5.1 0 0 0-1.27 1.031A4.05 4.05 0 0 0 .8 3.822a.75.75 0 1 0 .003 1.5 2.55 2.55 0 0 1 1.595.554 5 5 0 0 0-.391 1.284H.8a.75.75 0 1 0 0 1.5h1.185c.062.463.187.906.366 1.32a2.55 2.55 0 0 1-1.549.518.75.75 0 1 0-.004 1.5 4.05 4.05 0 0 0 2.347-.74A5.05 5.05 0 0 0 7 13.04a5.05 5.05 0 0 0 3.855-1.782 4.05 4.05 0 0 0 2.347.74.75.75 0 1 0-.004-1.5 2.55 2.55 0 0 1-1.549-.518c.179-.414.304-.857.366-1.32H13.2a.75.75 0 0 0 0-1.5h-1.206a5 5 0 0 0-.39-1.284 2.55 2.55 0 0 1 1.594-.554.75.75 0 0 0 .004-1.5 4.05 4.05 0 0 0-2.421.794 5.1 5.1 0 0 0-1.27-1.03 3.14 3.14 0 0 0 .624-1.875M7 4.42a3.56 3.56 0 0 1 3.222 2.043H3.778A3.56 3.56 0 0 1 7 4.419",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const programmingBug = { render };
export {
  programmingBug as default,
  render
};
//# sourceMappingURL=programming-bug.svg.js.map
